// @ts-ignore
import React, { useMemo } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import htmlEditButton from "quill-html-edit-button";
import "./TableModule"; // Import the custom TableModule
export const MultipleReactQuillEditor = ({
  id,
  name,
  value,
  onChange,
  onBlur,
}) => {
  const quillRef = React.useRef();
  const CustomUndo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
      <path
        className="ql-stroke"
        d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
      />
    </svg>
  );

  const CustomRedo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
      <path
        className="ql-stroke"
        d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
      />
    </svg>
  );

  function undoChange() {
    this.quill.history.undo();
  }

  function redoChange() {
    this.quill.history.redo();
  }

  const Size = Quill.import("formats/size");
  Size.whitelist = ["extra-small", "small", "medium", "large"];
  Quill.register(Size, true);

  Quill.register("modules/htmlEditButton", htmlEditButton);

  const Font = Quill.import("formats/font");
  Font.whitelist = [
    "arial",
    "comic-sans",
    "courier-new",
    "georgia",
    "helvetica",
    "lucida",
  ];
  Quill.register(Font, true);

  const CustomToolbar = () => (
    <div id={`toolbar-${id}`}>
      <span className="ql-formats">
        <select className="ql-font" defaultValue="arial">
          <option value="arial">Arial</option>
          <option value="comic-sans">Comic Sans</option>
          <option value="courier-new">Courier New</option>
          <option value="georgia">Georgia</option>
          <option value="helvetica">Helvetica</option>
          <option value="lucida">Lucida</option>
        </select>
        <select className="ql-size" defaultValue="10">
          <option value="extra-small">Size 1</option>
          <option value="small">Size 2</option>
          <option value="medium">Size 3</option>
          <option value="large">Size 4</option>
        </select>
        <select className="ql-header" defaultValue="3">
          <option value="1">Heading</option>
          <option value="2">Subheading</option>
          <option value="3">Normal</option>
        </select>
      </span>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
      </span>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
        <button className="ql-indent" value="-1" />
        <button className="ql-indent" value="+1" />
      </span>
      <span className="ql-formats">
        <button className="ql-script" value="super" />
        <button className="ql-script" value="sub" />
        <button className="ql-blockquote" />
        <button className="ql-direction" />
      </span>
      <span className="ql-formats">
        <select className="ql-align" />
        <select className="ql-color" />
        <select className="ql-background" />
      </span>
      <span className="ql-formats">
        <button className="ql-link" />
        <button className="ql-image" />
        <button className="ql-video" />
      </span>
      <span className="ql-formats">
        <button className="ql-formula" />
        <button className="ql-code-block" />
        <button className="ql-clean" />
      </span>
      <span className="ql-formats">
        <button className="ql-undo">
          <CustomUndo />
        </button>
        <button className="ql-redo">
          <CustomRedo />
        </button>
      </span>
      <span className="ql-formats">
        <button
          className="ql-insertTable"
          title="Insert Table"
          style={{ fontSize: "8px" }}
        >
          Table
        </button>
      </span>
    </div>
  );

  const handleChange = (val, delta, source, editor) => {
    onChange(name, val);
  };

  const quillModules = useMemo(() => {
    return {
      toolbar: {
        container: `#toolbar-${id}`,
        handlers: {
          undo: undoChange,
          redo: redoChange,
          insertTable: () => {
            const rows = parseInt(prompt("Enter the number of rows:", "2"), 10);
            const cols = parseInt(
              prompt("Enter the number of columns:", "2"),
              10
            );

            if (!isNaN(rows) && !isNaN(cols)) {
              quillRef.current
                .getEditor()
                .getModule("table")
                .insertTable(rows, cols);
            }
          },
        },
      },
      history: {
        delay: 500,
        maxStack: 100,
        userOnly: true,
      },
      htmlEditButton: {
        debug: true,
        msg: "Edit the content in HTML format",
        okText: "Ok",
        cancelText: "Cancel",
        buttonHTML: "<h5 class='ql-html d-flex'>&lt;&gt;</h5>",
        buttonTitle: "Show HTML source",
      },
      table: true, // Enable the custom table module
    };
  }, [id]);

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "align",
    "strike",
    "script",
    "blockquote",
    "background",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "code-block",
  ];

  return (
    <div>
      {CustomToolbar(id)}
      <ReactQuill
        ref={quillRef}
        style={{ backgroundColor: "white" }}
        theme="snow"
        value={value}
        onChange={(e, delta, source, editor) => {
          handleChange(e, delta, source, editor);
        }}
        modules={quillModules}
        formats={quillFormats}
        placeholder="Write content....."
        minLength="10"
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/component/admin/MultipleReactQuillEditor.js